<template>
  <section class="project-things-tab">
    <thingFirstLevel :disable-drag-n-drop="true"
                     :disable-check="isMotherPage" />
  </section>
</template>

<script>
  import {mapState} from 'vuex'
  // import {getThingsFromTree} from "../../../../mixins/things/getThingsFromTree";
  import thingFirstLevel from '../../../../components/Pages/Things/Things/thingFirstLevel'
  import {singleProject} from "../../../../mixins/projects/singleProject";

  export default {
    name: "projectThings",
    mixins: [singleProject],
    components: {thingFirstLevel},
    computed: {
      isMotherPage() {
        return this.$route.name === 'project-edit'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .moved_class-opacity {
    display: none!important;
  }

  .hidden-element {
    position: absolute;
    cursor: move;
  }

  .things-item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 60px;
    border-bottom: 1px solid $grey;
    //border-top: 1px solid $grey;

    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    color: $darkBlue;
    user-select: none;

    @media screen and (max-width: 1370px) {
      font-size: 12px;
    }

    &:hover {
      background: white;
      box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    }
  }


  .things-item_checked {
    background: rgba(215, 227, 234, .5)!important;
  }

  .legend-item {
    &:hover {
      background: none;
      box-shadow: none;
    }
  }

  //970

  .cell1 {
    min-width: 26px;
  }

  .item-assigned {
    .cell2 {
      width: 435/970 * 100%;
      padding-left: 20px;
      display: flex;
      align-items: center;
      padding-right: 10px;

      svg {
        margin-right: 20px;
        min-width: 40px;
      }
    }

    .cell3 {
      padding: 0 10px;
      width: 235/970 * 100%;
    }
    /*
        .cell4 {
          padding: 0 10px;
          width: 200/970 * 100%;
          display: flex;
          align-items: center;
        }

        .cell5 {
          padding: 0 10px;

          width:50/970 * 100%;
        }


        .cell6 {
          /*width: 30px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
        }*/

    .cell-hidden {
      width: 170/970 * 100%;

    }
  }

  .legend {
    font-family: $mr;
    font-size: 13px;
    color: $darkBlue;
    opacity: .5;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;


  }

  .avatar-cont {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 20px;
    background-size: contain;
    background-position: center;
    background-color: $grey;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      max-width: 60%;
    }
  }

  .moved_class {
    cursor: move;
    position: absolute;
    z-index: 100000;
    width: 100%;
    background: white;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    border-radius: 8px;
  }

  .hiddenClass {
    visibility: hidden!important;
  }

  .things-drop {
    border: 2px solid $lightBlue;
    border-radius: 8px;
  }

  .edit-btn {
    position: relative;
  }



</style>

